// Servidor de desarrollo compartido (prendadigitaldev.encodelabs.com.ar).
// Usado por `ng build --configuration dev-server` vía fileReplacements (angular.json) —
// distinto de environment.ts (localhost, para `ng serve`/desarrollo individual).
export const environment = {
  production: false,
  apiUrl: 'https://prendadigitaldev.encodelabs.com.ar/api',
};
